<template>
  <v-container>
    <h1 v-if="item">{{ item.place__name }}</h1>
    <h2>Eventi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Data inizio</th>
            <th>Data fine</th>
            <th>Tipo</th>
            <th>Concerto</th>
            <th>Strumenti</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in filteredEvents" :key="event.id">
            <td>
              {{ $formatDate($parseDate(event.start_date), "d MMMM y, H:mm") }}
            </td>
            <td>
              {{ $formatDate($parseDate(event.end_date), "d MMMM y, H:mm") }}
            </td>
            <td>{{ eventKinds[event.kind] }}</td>
            <td>
              {{
                get(
                  concerts.find((c) => c.id === event.concert),
                  "short_title"
                )
              }}
            </td>
            <td>
              <template v-for="instrumentId in event.instruments">
                {{
                  get(
                    showInstruments.find((p) => p.id === instrumentId),
                    "instrument__name"
                  )
                }},
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <h2 class="mt-8">Programmi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Concerto</th>
            <th>Gruppi</th>
            <th>Artisti</th>
            <th>Descrizione</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="concert in filteredConcerts" :key="concert.id">
            <td>
              {{ concert.short_title }}
            </td>
            <td>
              <template v-for="bandId in concert.bands">
                {{
                  get(
                    showBands.find((p) => p.id === bandId),
                    "band__name"
                  )
                }},
              </template>
            </td>
            <td>
              <template v-for="personId in concert.people">
                {{
                  get(
                    showPeople.find((p) => p.id === personId),
                    "person__name"
                  )
                }},
              </template>
            </td>
            <td>{{ concert.description }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <p style="margin-top: 20px;">
      <span v-if="get(item, 'internal_referent__name')">
        Referente luogo: {{ item.internal_referent__name }}
        <template v-if="get(item, 'internal_referent__telephone_number')">
          - Tel: {{ item.internal_referent__telephone_number }}
        </template>
        <template v-if="get(item, 'internal_referent__email')">
          - Mail: {{ item.internal_referent__email }}
        </template>
        <br />
      </span>
    </p>
    <p style="margin-top: 20px;">
      Info: Alfredo Bruno | Sofia Andreoli - Tel: +393761223166 - Mail:
      directorassistant@oficinaocm.com
      <br />
      Info travel/accomodation: Kati Gerola - Tel: +393517701823 - Mail:
      welcome@oficinaocm.com
    </p>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      item: null,
      eventKinds: {
        1: "evento pubblico",
        2: "prova",
        3: "accordatura",
      },
    }
  },
  computed: {
    showFk() {
      return this.$route.params.id
    },
    placeFk() {
      return this.$route.params.placeId
    },
    filteredEvents() {
      return this.events.filter((event) => {
        return event.place === parseInt(this.placeFk)
      })
    },
    filteredConcerts() {
      // get all concerts from the events
      const ids = this.filteredEvents
        .map((e) => e.concert)
        // get their unique ids
        .filter((v, i, a) => a.indexOf(v) === i)

      // map ids to concerts
      return ids.map((id) => this.concerts.find((p) => p.id === id))
    },
    ...mapState({
      loading(state) {
        return (
          state.events.pending.allEvents &&
          state.shows.pending.allConcerts &&
          // state.shows.pending.allShowPlaces &&
          state.shows.pending.show
        )
      },
      events(state) {
        return state.events.allEvents
      },
      concerts(state) {
        return state.concerts.allConcerts
      },
      showPeople(state) {
        return state.shows.allShowPeople
      },
      showBands(state) {
        return state.shows.allShowBands
      },
      showInstruments(state) {
        return state.shows.allShowInstruments
      },
      // showPlaces(state) {
      //   return state.shows.allShowPlaces
      // },
    }),
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch("listAllEvents", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllConcerts", {
        params: { show: this.showFk },
      })
      // this.$store.dispatch("listAllShowPlaces", {
      //   params: { show: this.showFk },
      // })
      this.$store.dispatch("listAllShowPeople", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllShowBands", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllShowInstruments", {
        params: { show: this.showFk },
      })
      this.axios.get(`/show-places/${this.placeFk}`).then((resp) => {
        this.item = resp.data
      })
    },
  },
}
</script>
